import { createStore } from "redux";
import Reducer from "./reducer";

//将store来进行暴露
export default createStore(Reducer);
